         <template>
          <v-container>
            <v-text-field label="เบอร์โทรศัพท์"
            v-model="dataFilter.phone_no">
            </v-text-field>
            <v-row>
              <v-col md="6">
                <v-menu v-model="fromDateMenu" :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field  label="From Date" readonly :value="fromDate" v-on = "on" ></v-text-field>
                  </template>
                  <v-date-picker @input="fromDateMenu = false"
                  no-title
                  v-model="fromDate"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col md="6">
                <v-menu v-model="endDateMenu" :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field  label="End Date" readonly :value="endDate" v-on = "on" ></v-text-field>
                  </template>
                  <v-date-picker @input="endDateMenu = false"
                  no-title
                  v-model="endDate"></v-date-picker>
                </v-menu>  
            </v-row>
            <v-row>
              <v-col md="3">
                <v-select
                  :items="select_item"
                  label="สถานะการเติมเงิน"
                  v-model="dataFilter.topup_status"
                ></v-select>
              </v-col>
              <v-col md="6"></v-col>
              <v-col md="12"></v-col>
            </v-row>
            <v-row>
              <v-col md="3"></v-col>
              <v-col md="6"><v-btn tile color="indigo" @click="searchFailHisy" dark>ค้นหา</v-btn></v-col>
              <v-col md="3"></v-col>
            </v-row>        
            <v-data-table
              :headers="table_header"
              :items="$store.getters.fail_trans_hist"
              :items-per-page="50"
              class="elevation-1"
            >
            </v-data-table >
          </v-container>
          </template>

<script>
import axios from 'axios';
import {store} from '../store/store'
export default {
  //name: Topuphist,
  store,
  data:()=>({
    trans_fail_hist:[],
    fromDateMenu : false,
    fromDate:"",
    fromDateDisp : "",
    endDateMenu : false,
    endDate : "",
    endDateDisp : "",
    phone_no : "",
    select_item:['','Success','Failed','รอผล'],
    dataFilter:{
      phone_no :"",
      start_date:"",
      end_date:"",
      topup_status:""
    },
    table_header:[
      {text:'วันที่-เวลา',value:'trans_date'},
      {text:'เครือข่าย',value:'phone_operation'},
      {text:'เบอร์โทร',value:'phone_no'},
      {text:'จำนวนเงิน',value:'trans_amount'},
      {text:'สถานะรายการ',value:'trans_status'},
      {text: '#ID',value:'trans_ref'},
      {text:'#Transaction',value:'trans_bill'},
    ]
  }),
  methods:{
    searchFailHisy:function(){
    axios
      .post('https://topup.gpsthaistar.com/api/indexPhp.php',{
        request:4,
        fromDate: this.fromDate,
        endDate: this.endDate,
        phoneNo: this.dataFilter.phone_no,
        topupStatus: this.dataFilter.topup_status,
      })
      .then((response)=>{
        this.trans_fail_hist = response.data;
        this.$store.commit('setFailtranshist',response.data);
        console.log(response.data);
      })
      .catch((err)=>{
        console.log("Error")
        console.log(err);
      })
    }
  },
  mounted(){
    axios
      .post('https://topup.gpsthaistar.com/api/indexPhp.php',{
        request:3,
      })
      .then((response)=>{
        this.trans_fail_hist = response.data;
        this.$store.commit('setFailtranshist',response.data);
        console.log(response.data);
      })
      .catch((err)=>{
        console.log("Error")
        console.log(err);
      })
  }

}
</script>